import React from 'react';
import { useNavigate } from 'react-router-dom';
import { askConfirm } from './AppDialogs';

// A record inside Optim, shown as a chip that opens it (ui-architecture.md
// "Record Lookup Field"): the record's icon and name in the accent blue on
// a pale blue pill. Used by RecordLookupField for a picked record, and on
// its own wherever a screen names another record (e.g. an Activity's "via"
// owner). size: 'md' in a form field, 'sm' inline in a row.
//
// A real link, so Ctrl-click or middle-click opens the record in a new tab;
// a plain click opens it here, passing origin ({ label, path }) so the
// record's breadcrumb leads back. hasUnsavedChanges() asks before leaving
// edits behind; noun names the form in that question (Quote, Sales Order).
function RecordChip({ label, href, icon: Icon, origin, noun, hasUnsavedChanges, title, size = 'md' }) {
  const navigate = useNavigate();

  const handleClick = async (e) => {
    // Inside a clickable row or click-to-edit field, the chip's click is its own.
    e.stopPropagation();
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (hasUnsavedChanges?.() && !(await askConfirm(`Leave without saving? Your changes to this ${noun} will be lost.`, { confirmLabel: 'Leave', destructive: true }))) return;
    navigate(href, { state: origin ? { origin } : undefined });
  };

  return (
    <a href={href} onClick={handleClick} title={title} className={`record-chip record-chip-${size}`}>
      {Icon && <Icon size={size === 'sm' ? 12 : 15} strokeWidth={2} style={{ flexShrink: 0 }} />}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      <style>{CHIP_CSS}</style>
    </a>
  );
}

const CHIP_CSS = `
.record-chip {
  display: inline-flex; align-items: center; min-width: 0; max-width: 100%;
  border-radius: 999px; background: #e8f1fb; border: 1px solid #c6dbf3; color: #1565c0;
  font-weight: 600; text-decoration: none; vertical-align: middle;
}
.record-chip:hover { background: #d6e7f8; text-decoration: underline; }
.record-chip-md { gap: 6px; padding: 3px 10px 3px 8px; font-size: 14px; }
.record-chip-sm { gap: 4px; height: 18px; padding: 0 7px 0 6px; font-size: 11px; }
`;

export default RecordChip;
